import type { AxiosResponse } from 'axios'

/**
 * Extracts the data property from an Axios response.
 * Use as a response interceptor fulfilled handler.
 */
export const extractResponseData = (response: AxiosResponse): AxiosResponse['data'] => response.data
